export default __webpack_public_path__ + "static/landing-collab-bottom-image-b-b45c1c8f21350257578250a324d0d9ac.png";